import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../provider/auth.provider";
import jwt from "jwt-decode";
import RoleEnum from "../ts/enum/role.enum";
import useLocalization from "./useLocalization";
import _ from "lodash";
interface returner {
  accessToken: string;
  hasPermission: (
    mustPermission: {
      route: string;
      method: "GET" | "POST" | "DELETE" | "PATCH";
    }[]
  ) => boolean;
  permissions: { route: string; method: "GET" | "POST" | "DELETE" | "PATCH" }[];
  refreshToken: string;
  isLogedIn: boolean;
  logout: any;
  decode: any;
  setAuth: any;
  hasRole: (role: RoleEnum) => boolean;
  apiPermission: (apis: string[], paramsKeyValue?: any) => string;
}

const useAuth = (): returner => {
  const { authState, setAuth, setIsLogedIn, isLogedIn } =
    useContext(AuthContext);
  const { accessToken, refreshToken, permissions } = authState || {};
  let decode: any = accessToken && jwt(accessToken);
  if (!decode) {
    decode = {};
  }
  const logout = () => {
    localStorage.removeItem("auth");
    setAuth();
    return setIsLogedIn(false);
  };

  // const { getLanguage } = useLocalization()

  // console.log("hapogetLanguage",getLanguage())

  const hasPermission = (
    mustPermission: {
      route: string;
      method: "GET" | "POST" | "DELETE" | "PATCH";
    }[]
  ): boolean => {
    return permissions?.some(({ method: iMethod, route: iRoute }: any) =>
      mustPermission?.some(
        ({ method, route }) => method == iMethod && route == iRoute
      )
    );
  };

  const apiPermission = (apis: string[], paramsKeyValue?: any) => {
    let api: string = permissions?.find(
      ({ method: iMethod, route: iRoute }: any) =>
        apis?.map((i) => i.toLowerCase()).some((api) => api == iRoute)
    )?.route;
    if (paramsKeyValue) {
      _.forIn(paramsKeyValue, (val, key) => {
        api = api?.replace(`:${key}`, val);
      });
    }

    return api;
  };

  const hasRole = (role: RoleEnum): boolean => {
    return decode?.roleIds?.some((item: any) => item == role);
  };
  return {
    accessToken,
    hasPermission,
    permissions,
    refreshToken,
    isLogedIn,
    logout,
    decode,
    setAuth,
    hasRole,
    apiPermission,
  };
};

export default useAuth;
